import { signUp, signIn, signOut,
        confirmSignUp, resendSignUpCode,
        getCurrentUser, fetchUserAttributes, updateUserAttributes,
        resetPassword, confirmResetPassword, fetchAuthSession } from 'aws-amplify/auth';

export const authService = {
  // Current Cognito ID token (JWT) as a string, or null. fetchAuthSession
  // transparently refreshes it when near expiry, so this is always fresh.
  // The backend verifies it and reads the user's identity from the token.
  async getIdToken() {
    try {
      const session = await fetchAuthSession();
      return session.tokens?.idToken?.toString() || null;
    } catch (error) {
      console.error('Failed to get ID token:', error);
      return null;
    }
  },

  // Sign up a new user
  async signUp(email, password, name = null) {
    try {
      const nameFormatted = name?.formatted || name || email.split('@')[0];
      
      // Create the user with userAttributes in options object (correct Amplify v6 format)
      const result = await signUp({
        username: email,
        password: password,
        options: {
          userAttributes: {
            email: email,
            name: nameFormatted,
          },
        },
      });
      
      return { success: true, user: result };
    } catch (error) {
      console.error('Sign up error:', error);
      return { success: false, error: error.message };
    }
  },

  // Confirm sign up with verification code
  async confirmSignUp(email, code) {
    try {
      await confirmSignUp({
        username: email,
        confirmationCode: code,
      });
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Resend verification code
  async resendSignUpCode(email) {
    try {
      await resendSignUpCode({
        username: email,
      });
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Sign in user
  async signIn(email, password) {
    try {
      const user = await signIn({
        username: email,
        password: password,
      });
      
      return { success: true, user };
    } catch (error) {
      console.log(error)
      return { success: false, error: error.message };
    }
  },

  // Sign out user
  async signOut() {
    try {
      await signOut();
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Get current authenticated user
  async getCurrentUser() {
    try {
      const user = await getCurrentUser();
      return { success: true, user };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Get current user with attributes
  async getCurrentUserWithAttributes() {
    try {
      const user = await getCurrentUser();
      const attributes = await fetchUserAttributes();
      return { success: true, user: { ...user, attributes } };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

   async updateUserName(name) {
    try {
      await updateUserAttributes({
        userAttributes: {
          name: name,
        },
      });
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Reset password (forgot password)
  async resetPassword(email) {
    try {
      const output = await resetPassword({
        username: email,
      });
      return { success: true, output };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Confirm reset password with code
  async confirmResetPassword(email, code, newPassword) {
    try {
      await confirmResetPassword({
        username: email,
        confirmationCode: code,
        newPassword: newPassword,
      });
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

};